import { resolve } from '../../../../../init/store';

export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        if (!this.application) {
            this.key = 'configure_application.radius.configure_later';
        } else if (!this.application.applicationApiKey) {
            this.key = 'configure_application.radius.load-credentials';
        }
    }

    loadCredentials() {
        if (this.application && !this.application.applicationApiKey) {
            resolve.credentials$.get();
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/app-integration-instructions/local/app-api-credentials/app-api-credentials.controller.js